import { BaseApi } from "@newview/infrastructure";
export abstract class basicBaseApi extends BaseApi {
    public get ProxyName(): any {
        return 'basicBaseApi';
    }
  
}